<template>
  <div class="channel-banner-carousel">
    <!-- 标题 -->
    <span class="channel-banner-carousel__title" @click="goDetail(currentItem)">{{ currentItem.title }}</span>

    <!-- 图片区域 -->
    <div class="channel-banner-carousel__image-wrap" @click="goDetail(currentItem)">
      <img
        class="channel-banner-carousel__image"
        referrerpolicy="no-referrer"
        :src="currentImage"
        :alt="currentItem.title"
      />
      <!-- 底部渐变 + 指示器 -->
      <div class="channel-banner-carousel__overlay">
        <span
          v-for="(item, idx) in items"
          :key="idx"
          class="channel-banner-carousel__dot"
          :class="{ 'channel-banner-carousel__dot--active': idx === activeIndex }"
          @click.stop="goTo(idx)"
        ></span>
        <span class="channel-banner-carousel__number">{{ padNumber }}</span>
      </div>
    </div>

    <!-- 来源 + 时间 -->
    <div class="channel-banner-carousel__meta">
      <span class="channel-banner-carousel__source">{{ currentItem.source }}</span>
      <span class="channel-banner-carousel__time">{{ currentItem.time }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChannelBannerCarousel',
  props: {
    items: {
      type: Array,
      required: true
      // 每项: { title, image, source, time }
    },
    interval: {
      type: Number,
      default: 4000 // 自动播放间隔，毫秒
    }
  },
  data() {
    return {
      activeIndex: 0,
      timer: null
    };
  },
  computed: {
    currentItem() {
      return this.items[this.activeIndex] || {};
    },
    currentImage() {
      return this.currentItem.coverImage || this.currentItem.thumbnail || this.currentItem.image || '';
    },
    padNumber() {
      return String(this.activeIndex + 1).padStart(2, '0');
    }
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    goTo(idx) {
      this.activeIndex = idx;
      this.restartAutoPlay();
    },
    next() {
      this.activeIndex = (this.activeIndex + 1) % this.items.length;
    },
    startAutoPlay() {
      this.timer = setInterval(() => {
        this.next();
      }, this.interval);
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    restartAutoPlay() {
      this.stopAutoPlay();
      this.startAutoPlay();
    },
    goDetail(item) {
      if (!item) return;
      const newsCode = item.newsCode || item.id;
      if (!newsCode) return;
      this.$router.push(`/detail?newsCode=${newsCode}`);
    }
  }
};
</script>

<style scoped>
.channel-banner-carousel {
  width: var(--content-width);
  margin-left: var(--space-6);
}

/* 标题 */
.channel-banner-carousel__title {
  display: block;
  width: 100%;
  color: var(--color-black);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  font-weight: var(--weight-bold);
  text-align: left;
  line-height: 40px;
  margin: 20px 0 0;
  cursor: pointer;
}

/* 图片容器 */
.channel-banner-carousel__image-wrap {
  position: relative;
  width: 100%;
  height: 425px;
  margin-top: 10px;
  overflow: hidden;
  border-radius: var(--radius-sm);
  cursor: pointer;
}

.channel-banner-carousel__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 底部渐变覆盖层 */
.channel-banner-carousel__overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 87px;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
}

.channel-banner-carousel__dot {
  display: block;
  width: 80px;
  height: var(--space-1);
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: var(--space-5);
  margin-right: 14px;
  cursor: pointer;
  transition: background-color var(--transition-fast);
}

.channel-banner-carousel__dot:first-child {
  margin-left: 22px;
}

.channel-banner-carousel__dot--active {
  background-color: rgba(255, 255, 255, 1);
}

.channel-banner-carousel__number {
  color: var(--color-white);
  font-size: var(--font-md);
  font-family: var(--font-number);
  font-weight: var(--weight-bold);
  white-space: nowrap;
  line-height: 20px;
  margin: -15px 0 0 13px;
}

/* 来源 + 时间 */
.channel-banner-carousel__meta {
  display: flex;
  align-items: center;
  width: 100%;
  height: 28px;
  margin-top: 17px;
}

.channel-banner-carousel__source,
.channel-banner-carousel__time {
  color: var(--color-text-light);
  font-size: var(--font-base);
  font-family: var(--font-primary);
  white-space: nowrap;
  line-height: 18px;
}

.channel-banner-carousel__time {
  margin-left: 16px;
}
</style>
